import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const TccCertificatePage = lazy(() => import("@/features/dashboard/pages/tcc-certificate"));

export const Route = createFileRoute("/(app)/dashboard/tcc")({
  component: () => (
    <Suspense fallback={<div className="text-muted-foreground text-sm">Loading certificate…</div>}>
      <TccCertificatePage />
    </Suspense>
  ),
});
